const Logger = {};
Logger.error = (error) => {
  console.error(error);
  const xhr = new XMLHttpRequest();

  xhr.open('POST', `${process.env.VUE_APP_API}/log`, true);
  xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  xhr.send(JSON.stringify({
    level: 'error',
    log: error,
    url: window.location.href
  }));
};

Logger.vueErrorHandler = (err, vm, info) => {
  console.error('********************************');
  console.error(err);
  console.error(vm);
  console.error(info);
  console.error('********************************');
  Logger.error(`${err.toString()}:${info}`);
};

// Catch uncaught errors
window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
  Logger.error(`${url}:${lineNumber}: ${errorMsg}`);
  return false;
};

export default Logger;
